import ReactGA from 'react-ga4'

export const gaInit = () => {
  console.info(`ENV: ${process.env.DEPLOY_ENV}`)
  console.info(
    `📈 GA: Init Analytics ${process.env.APP_GA} | 🧪 Test mode: ${!(
      process.env.DEPLOY_ENV === 'prod' || process.env.DEPLOY_ENV === 'staging'
    )} | 🐞 Debug mode: ${!(process.env.DEPLOY_ENV === 'prod')}`
  )
  if (process.env.APP_GA) {
    ReactGA.initialize(process.env.APP_GA, {
      testMode: !(
        process.env.DEPLOY_ENV === 'prod' ||
        process.env.DEPLOY_ENV === 'staging'
      ),
      gaOptions: {
        debug_mode: !(process.env.DEPLOY_ENV === 'prod'),
      },
    })
    ReactGA.set({
      app_name: 'Embrace Boston',
    })
  }
}

export const gaSendEvent = (name: string) => {
  console.info(`📉 GA: Send Event ${name}`)

  ReactGA.send({
    hitType: 'pageview',
    page_title: name,
    page: name,
  })
}

export const gaSendCustomEvent = (
  name: string,
  data: { [key: string]: unknown } = { app_name: 'Embrace Boston' }
) => {
  console.info(`📉 GA: Custom Event ${name}`)
  ReactGA.event(name, data)
}

export const gaSendPageview = (path: string) => {
  console.info(`📉 GA: Send Page View ${path}`)
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    page_title: path,
  })
}
